import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const currentLanguage = (navigator.language).includes('en') ? 'en' : 'fr';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false
  }
}

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    returnNull: false,
    load: 'languageOnly',
    debug: true,
    fallbackLng: "fr",
    backend: {
      loadPath: `/locales/${currentLanguage}/translation.json`, // Adjust the path as needed
    },
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
